export default __webpack_public_path__ + "3199787e884e257c9b1e99f17b63c14f.png";